import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { GoogleAuthProvider } from "firebase/auth";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { loginUserWithOAuth } from "../utils/loginUserWithOAuth";
import { getConfig } from "@shared/services/api/config";
import { AppType } from "@shared/types/app.types";

type Args = {
  onSuccess?: (data: any) => void;
  onError?: () => void;
  form: UseFormReturn<z.AnyZodObject>;
};

export function useGoogleLoginMutation({ onSuccess, form, onError }: Args) {
  const { appName } = getConfig();

  return useMutation({
    mutationFn: async () => {
      return await loginUserWithOAuth(
        appName as AppType,
        new GoogleAuthProvider(),
        onError
      );
    },
    onError: (error: Error) => {
      form.setError("root", {
        type: "manual",
        message: formatFirebaseError(error.message),
      });
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useGoogleLoginMutation;
